
































import { CategoryName } from "@/models/CategoryName";
import { DecomojiName } from "@/models/DecomojiName";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DecomojiButton extends Vue {
  // 入力プロパティを定義する
  @Prop() category!: CategoryName;
  @Prop() name!: DecomojiName;
  @Prop({ default: false }) collected!: boolean;
  @Prop({ default: undefined }) created!: string;
  @Prop({ default: undefined }) updated!: string;
}
